// frontend/src/components/client/ClientStatsCards.jsx
import React from 'react';
import { Fuel, Wrench, CreditCard, Calendar, RefreshCw } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, onClick }) => (
  <div
    onClick={onClick}
    className="bg-gray-800/50 rounded-xl border border-gray-700 p-3 sm:p-4 cursor-pointer hover:bg-gray-800/70 active:bg-gray-700/70 transition"
  >
    <div className="flex items-center justify-between gap-2">
      <div className="flex-1 min-w-0">
        <p className="text-gray-400 text-xs sm:text-sm leading-tight">{title}</p>
        <p className="text-xl sm:text-2xl font-bold text-white mt-1 truncate">{value}</p>
      </div>
      <div className={`p-2.5 sm:p-3 rounded-lg flex-shrink-0 ${color}`}>
        <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
      </div>
    </div>
  </div>
);

const ClientStatsCards = ({ stats, loading, onRefresh }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-gray-800/50 rounded-xl border border-gray-700 p-3 sm:p-4 animate-pulse">
            <div className="h-14 sm:h-16 bg-gray-700/50 rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button
          onClick={onRefresh}
          className="p-2 hover:bg-gray-700 active:bg-gray-600 rounded-lg text-gray-400 transition"
          title="Refresh"
        >
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
      {/* 2 cols on mobile, 4 on desktop */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <StatCard
          title="Fuel Requests"
          value={stats?.fuel_requests_pending || 0}
          icon={Fuel}
          color="bg-orange-500/20 text-orange-400"
        />
        <StatCard
          title="Maintenance"
          value={stats?.maintenance_requests_pending || 0}
          icon={Wrench}
          color="bg-red-500/20 text-red-400"
        />
        <StatCard
          title="Pending Invoices"
          value={`${stats?.invoices_pending_count || 0}`}
          icon={CreditCard}
          color="bg-yellow-500/20 text-yellow-400"
        />
        <StatCard
          title="Upcoming Events"
          value={stats?.upcoming_events || 0}
          icon={Calendar}
          color="bg-blue-500/20 text-blue-400"
        />
      </div>
    </div>
  );
};

export default ClientStatsCards;